import type { ProductState } from 'src/redux/product/types';
import { ProductFeature } from '../components/ProductFeatures';

type ProductFeatures = Pick<ProductState, 'allowsGiftWrap' | 'productRating' | 'specialFeatures'>;

export const getTopProductFeatures = ({
  allowsGiftWrap,
  productRating,
  specialFeatures,
}: ProductFeatures): ProductFeature[] => {
  const { madeInBritain, personalisable, requiresPhotoUpload } = specialFeatures;
  const features = [];

  if (productRating !== null && productRating > 4.5) {
    features.push(ProductFeature.LoveByCustomers);
  }

  if (madeInBritain) {
    features.push(ProductFeature.MadeInBritain);
  }

  if (requiresPhotoUpload) {
    features.push(ProductFeature.PhotoPersonalisation);
  }

  if (!requiresPhotoUpload && personalisable) {
    features.push(ProductFeature.Personalisable);
  }

  if (allowsGiftWrap) {
    features.push(ProductFeature.GiftWrappingAvailable);
  }

  return features.slice(0, 3);
};
